import React from 'react'
import { Box, ImageLoader } from '@usap/uicomponents'
import Lightbox from '../../common/Lightbox'
import HowToVideo from './Forms/HowToVideo'
import { Heading5 } from '../../common/heading'

const videoImageUrl = 'https://cld.partsimg.com/image/upload/d_noimage,c_pad,f_auto,q_auto,dpr_auto/carparts/images/image'

const videos = {
  bumpercover: {
    videoHeader: 'How to Unfold Your Bumper Cover',
    videoUrl: 'https://www.youtube.com/embed/xJiEa1lD2Zk',
    videoImage: videoImageUrl,
  },
  hood: {
    videoHeader: 'How to Check Your Hood Upon Delivery',
    videoUrl: 'https://www.youtube.com/embed/2uuh2TDiWIk',
    videoImage: videoImageUrl,
  },
  fender: {
    videoHeader: 'How to Check Your Fender Upon Delivery',
    videoUrl: 'https://www.youtube.com/embed/PsAEBzkAT6U',
    videoImage: videoImageUrl,
  },
}

const VideoLightBox = props => {
  const {
    isBot,
    showVideo,
    setShowVideo,
    partText,
    isPartHasVideo,
  } = props

  if (!isPartHasVideo) {
    return null
  }

  const partKey = partText.toLowerCase().replace(/\s/g, '')
  if (!videos[`${partKey}`]) {
    return null
  }

  const {
    videoHeader,
    videoUrl,
    videoImage,
  } = videos[`${partKey}`]

  return (
    <>
      <Lightbox isDisplay={showVideo}>
        <HowToVideo key="videoHolder" videoUrl={videoUrl} setShowVideo={setShowVideo} />
      </Lightbox>
      <Box
        pad="medium"
        style={{
          border: '1px solid #E0E0E0',
          borderRadius: '6px',
        }}
      >
        <Box>
          <Heading5
            title={videoHeader}
            style={{
              fontSize: '16px',
              fontWeight: 700,
              marginBottom: '8px',
            }}
          />
        </Box>
        <Box onClick={() => setShowVideo(true)} style={{ cursor: 'pointer' }}>
          <ImageLoader
            key="videoThumb"
            src={videoImage}
            alt={videoHeader}
            isBot={isBot}
            fit="contain"
            layout="fixed"
            height="100%"
            width="100%"
          />
        </Box>
      </Box>
    </>
  )
}

export default VideoLightBox
